// @flow
import { Grid } from 'semantic-ui-react';
import { SelectField } from '@src/formik-utils/FormFields';
import React, { useContext } from 'react';
import { getDropdownOptions } from '@components/stream-governance/utils';
import { SPUserCommitMetadataContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitMetadataContext';
import {
  getDimensionsPath,
  getIfGivenRowIsANewlyAddedRow,
} from '@streaming-projects/user-commit-details/committed-capacity/utils';

export const CFUDimensionColumns = ({ metricIndex, dimensionIndex, row }) => {
  const dimensionsPath = getDimensionsPath(metricIndex, dimensionIndex);
  const providerPath = `${dimensionsPath}.provider`;

  const providerColConfig = {
    backendFieldName: 'provider',
    displayNameCol: 'provider_label',
    parentFieldsInGroup: [],
  };

  const dataUniverse =
    useContext(SPUserCommitMetadataContext)?.committed_cfu_capacity_configs ?? [];

  const providerDropDownOptions = getDropdownOptions(
    dataUniverse,
    row,
    providerColConfig,
    false,
    false,
    false,
    true
  );

  const shouldColumnBeDisabled = !getIfGivenRowIsANewlyAddedRow(row);

  return (
    <Grid.Column width={3}>
      <SelectField
        addLabel={false}
        disableOnFormErrors={false}
        disabled={shouldColumnBeDisabled}
        fieldDisplayName="Cloud Provider"
        fieldName={providerPath}
        options={providerDropDownOptions}
      />
    </Grid.Column>
  );
};
